/**
 * WelcomeHintModal Component
 * 
 * Welcome modal shown to new users with helpful tips and getting started guide.
 * NOTE: Behavior copied from legacy App.js, do not change without regression testing.
 * 
 * @component
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Callback to close modal
 */

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { CheckCircle } from 'lucide-react';

function WelcomeHintModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">
            🎉 Welcome to CaterLog!
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 p-4">
          <p className="text-center text-gray-600">
            As a first-time user, here's how to get started:
          </p>
          
          <div className="space-y-4 bg-green-50 p-6 rounded-lg">
            <div className="flex items-start gap-3">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">1</div>
              <div>
                <h3 className="font-semibold text-green-900">Set Up Your Store</h3>
                <p className="text-sm text-gray-700">Go to <strong>Settings → Store Setup</strong> to add your logo, tagline, and store information</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">2</div>
              <div>
                <h3 className="font-semibold text-green-900">Import Your Menu</h3>
                <p className="text-sm text-gray-700">
                  <strong>Download the menu import template</strong> from Store Setup → Menu Import tab<br/>
                  Add your catering items to this template<br/>
                  Upload it back to CaterLog - we'll handle the rest!
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">3</div>
              <div>
                <h3 className="font-semibold text-green-900">Build Your Team (Optional)</h3>
                <p className="text-sm text-gray-700">Invite staff members to help manage orders</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0">4</div>
              <div>
                <h3 className="font-semibold text-green-900">Start Taking Orders!</h3>
                <p className="text-sm text-gray-700">Create your first order and experience CaterLog in action</p>
              </div>
            </div>
          </div>
          
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-blue-900">
              <strong>💡 Tip:</strong> You're on a 14-day free trial. Take your time to explore all features!
            </p>
          </div>
          
          <div className="text-center">
            <Button 
              onClick={onClose}
              className="btn-bawarchi-primary px-8 py-2"
            >
              Got It! Let's Get Started
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// Floating Contact Us Button Component

export default WelcomeHintModal;
